// Ordered to match the $avatarcolors map in src/assets/sass/core/_variables.scss, so the class name and the
// hex returned here resolve to the same color the avatar renders via CSS. Keep both lists in sync.
export const AVATAR_COLORS: { name: string; hex: string }[] = [
  { name: 'madison', hex: '#0c2461' },
  { name: 'pickledBluewood', hex: '#303952' },
  { name: 'jungleGreen', hex: '#27ae60' },
  { name: 'taraweraapprox', hex: '#0a3d62' },
  { name: 'burntOrange', hex: '#d35400' },
  { name: 'shuttleGray', hex: '#596275' },
  { name: 'keppel', hex: '#38ada9' },
  { name: 'ming', hex: '#3c6382' },
  { name: 'jacksonsPurple', hex: '#1e3799' },
  { name: 'wisteriaapprox', hex: '#9b59b6' },
  { name: 'neonCarrot', hex: '#fa983a' },
  { name: 'victoria', hex: '#574b90' },
  { name: 'fountainBlue', hex: '#60a3bc' },
  { name: 'indigo', hex: '#4a69bd' },
  { name: 'yellowGreen', hex: '#b8e994' },
  { name: 'cascade', hex: '#95a5a6' },
  { name: 'terracotta', hex: '#e17055' },
  { name: 'cherokee', hex: '#fad390' },
  { name: 'radicalRed', hex: '#ff1e63' },
  { name: 'saffron', hex: '#DE8E2A' },
  { name: 'kimberly', hex: '#786fa6' }
];

function numberFromText(text: string): number {
  const charCodes = (text ?? '').split('').map(char => char.charCodeAt(0)).join('');
  return parseInt(charCodes, 10);
}

// Returns -1 when the name yields no number (e.g. empty), matching the avatar's original behavior of leaving
// no color class so the CSS default (primary) applies.
function avatarColorIndex(name: string): number {
  const num = numberFromText(name);
  return isNaN(num) ? -1 : num % AVATAR_COLORS.length;
}

// CSS class name used by the avatar component; empty for nameless avatars (CSS default applies).
export function avatarColorClass(name: string): string {
  const index = avatarColorIndex(name);
  return index < 0 ? '' : AVATAR_COLORS[index].name;
}

// Hex value matching that class, for places that need an inline background color (e.g. card banners).
export function avatarColorHex(name: string): string {
  const index = avatarColorIndex(name);
  return index < 0 ? '' : AVATAR_COLORS[index].hex;
}
